/* istanbul ignore file */
import { Component } from '@angular/core';

@Component({
  selector: 'app-invite-expired',
  templateUrl: './invite-expired.component.html',
  styleUrls: ['./invite-expired.component.scss']
})
export class InviteExpiredComponent {
  constructor(
    
  ) { }

  ngOnInit() {

  }
}
